import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, ButtonBase } from '@mui/material';

// project imports
// import SearchSection from './SearchSection';
import ProfileSection from './ProfileSection/index';
import NotificationSection from './NotificationSection';
import Setting from './Setting';


// assets
// import { IconMenu2 } from '@tabler/icons';
import Iconify from '../../../component/iconify/Index';


// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = ({ handleLeftDrawerToggle }) => {
    const theme = useTheme();

    return (
        <>
            {/* logo & toggler button */}
            <Box
                sx={{
                    width: 228,
                    display: 'flex',
                    // background:"#000",
                    [theme.breakpoints.down('md')]: {
                        width: 'auto'
                    }
                }}
            >
             
            </Box>

            {/* header search */}
            {/* <SearchSection /> */}
            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ flexGrow: 1 }} />

            {/* notification & profile */}
            <NotificationSection />
            <Setting/>
            <ProfileSection />
        </>
    );
};

Header.propTypes = {
    handleLeftDrawerToggle: PropTypes.func
};

export default Header;